function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z",
  id: "email_svg__a"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("use", {
  xlinkHref: "#email_svg__a"
});

var SvgEmail = function SvgEmail(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPGRlZnM+CiAgICAgICAgPHBhdGggZD0iTTIwLDQgTDQsNCBDMi45LDQgMi4wMSw0LjkgMi4wMSw2IEwyLDE4IEMyLDE5LjEgMi45LDIwIDQsMjAgTDIwLDIwIEMyMS4xLDIwIDIyLDE5LjEgMjIsMTggTDIyLDYgQzIyLDQuOSAyMS4xLDQgMjAsNCBaIE0yMCw4IEwxMiwxMyBMNCw4IEw0LDYgTDEyLDExIEwyMCw2IEwyMCw4IFoiIGlkPSJwYXRoLTEiPjwvcGF0aD4KICAgIDwvZGVmcz4KICAgIDx1c2UgaWQ9IlNoYXBlIiBmaWxsPSIjMDAwMDAwIiBmaWxsLXJ1bGU9Im5vbnplcm8iIHhsaW5rOmhyZWY9IiNwYXRoLTEiPjwvdXNlPgo8L3N2Zz4K";
export { SvgEmail as ReactComponent };